var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58675 7.08667C6.39025 7.26977 6.23265 7.49057 6.12334 7.7359C6.01402 7.98123 5.95524 8.24607 5.95051 8.51461C5.94577 8.78315 5.99517 9.04989 6.09576 9.29893C6.19635 9.54796 6.34607 9.77419 6.53598 9.96411C6.7259 10.154 6.95212 10.3037 7.20116 10.4043C7.45019 10.5049 7.71694 10.5543 7.98548 10.5496C8.25402 10.5448 8.51885 10.4861 8.76419 10.3768C9.00952 10.2674 9.23032 10.1098 9.41342 9.91334",
    stroke: "#94A3B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15332 3.88671C7.43419 3.85171 7.71694 3.8339 7.99999 3.83337C12.6667 3.83337 14.6667 8.50004 14.6667 8.50004C14.3686 9.13812 13.9948 9.738 13.5533 10.2867",
    stroke: "#94A3B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40683 4.90662C3.081 5.8097 2.02008 7.05012 1.3335 8.49995C1.3335 8.49995 3.3335 13.1666 8.00016 13.1666C9.27744 13.17 10.5274 12.7967 11.5935 12.0933",
    stroke: "#94A3B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 1.83337L14.6668 15.1667",
    stroke: "#94A3B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.cc8107b3c019b4f61c07f172802927d7.svg";
export { ForwardRef as ReactComponent };